import { useQuery } from "@tanstack/react-query";

import type { EncryptionNetworkConfig } from "@/lib/statsig-configs";
import { Logger } from "@/utils/logger";

export function encryptionConfigQueryKey() {
  return ["statsig", "encryption-config"] as const;
}

export function useEncryptionConfigQuery(placeholderData: EncryptionNetworkConfig) {
  return useQuery({
    queryKey: encryptionConfigQueryKey(),
    queryFn: async () => {
      const res = await fetch("/api/statsig/encryption-config");
      if (!res.ok) throw new Error(`encryption-config fetch failed: ${res.status}`);
      return res.json() as Promise<EncryptionNetworkConfig>;
    },
    placeholderData,
    staleTime: 30_000,
    refetchInterval: 30_000,
    retry: (failureCount, err) => {
      const shouldRetry = failureCount < 3;
      if (!shouldRetry) Logger.error(err, { feature: "statsig-encryption-config" });
      return shouldRetry;
    },
  });
}
